import { cn } from "@aurem/ui";
import { cva, VariantProps } from "class-variance-authority";
import type { FC, HTMLAttributes, ReactNode } from "react";

export const cardVariants = cva("w-full flex flex-col justify-between gap-2 ", {
  variants: {
    size: {
      small: "rounded-md",
      medium: "rounded-2xl",
      large: "rounded-3xl",
    },
    intent: {
      normal: "bg-white text-black p-3 lg:p-8",
      inverted: "bg-black text-neutral-100 p-3 lg:p-8",
      blue: "bg-[#7EACFF] text-black p-3 lg:p-8",
      grey: "bg-neutral-500/5 text-neutral-500 p-4",
      unset: "",
      pretty: "bg-white p-12 shadow-[0_0_4px_0_rgba(196,196,199,1)]",
      danger: "bg-danger-100 text-danger-800 p-4",
    },
    outline: {
      true: "border border-neutral-500/10",
      false: "",
    },
  },
  defaultVariants: {
    size: "medium",
    intent: "normal",
    outline: false,
  },
});

export interface CardProps
  extends HTMLAttributes<HTMLElement>,
    VariantProps<typeof cardVariants> {
  className?: string;
  children?: ReactNode;
}

export const Card: FC<CardProps> = ({
  className,
  children,
  size,
  intent,
  outline,
  ...props
}) => {
  return (
    <section
      className={cn(cardVariants({ size, intent, outline }), className)}
      {...props}
    >
      {children}
    </section>
  );
};
